import { render } from "./ShopDuvets.vue?vue&type=template&id=77c3f278"
import script from "./ShopDuvets.vue?vue&type=script&lang=js"
export * from "./ShopDuvets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__